<template>
  <div
    class="tag-matrix-title-holder"
    :class="selectedTab === tabIndex ? 'title-highlight' : ''"
  >
    <div class="tag-highlight-spacer" />
    <div class="text-holder">
      {{ $props.title }}
    </div>
    <div
      class="tag-highlight"
      :class="selectedTab === tabIndex ? 'highlight' : ''"
    />
  </div>
</template>

<script>
import { useRMTStore } from '@/store/RMTStore';

export default {
  name: 'TagMatrixTitle',
  props: [
    'title',
    'tabIndex'
  ],
  emits: [
    'setIndex'
  ],
  computed: {
    selectedTab () {
      const RMTStore = useRMTStore();
      return RMTStore.selectedTab;
    },
  },
};
</script>

<style scoped>
.tag-matrix-title-holder {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  background-color: white;
  height: 50px;
  font-size: .82em;
  font-weight: 600;
  flex-direction: column;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
}
.tag-matrix-title-holder:hover {
  background-color: lightgrey !important;
}
.text-holder {
  white-space: nowrap;
  padding-left: 30px;
  padding-right: 30px;
}
.title-highlight {
  background-color: #9d9d9d;
}
.tag-highlight {
  width: 100%;
  height: 1px;
  background-color: #2c3e50;
}
.tag-highlight-spacer {
  width: 100%;
  height: 3px;
  background-color: transparent;
}
.highlight {
  height: 2px;
  color: #9c9c9c;
  transition: height .2s, background-color .2s;
  transition-timing-function: ease;
}
</style>